import { render, staticRenderFns } from "./historicalSituation.vue?vue&type=template&id=6a2ede9d&scoped=true"
import script from "./historicalSituation.vue?vue&type=script&lang=js"
export * from "./historicalSituation.vue?vue&type=script&lang=js"
import style0 from "./historicalSituation.vue?vue&type=style&index=0&id=6a2ede9d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2ede9d",
  null
  
)

export default component.exports